import { siteUrl, absoluteUrl, SEO_IMAGES } from './seo';
import { products } from '@/mocks/products';

const PUBLISH_DATE = '2026-08-26';
const ORG_NAME = 'CSSBuyBR Team';

function langCode(lang: string): string {
  if (lang === 'pt') return 'pt-BR';
  if (lang === 'de') return 'de';
  return 'en';
}

export function injectJsonLd(scripts: object[]): void {
  if (typeof document === 'undefined') return;
  document.head.querySelectorAll('script[data-seo-jsonld]').forEach((node) => node.remove());
  scripts.forEach((data) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-seo-jsonld', '');
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
  });
}

export function clearJsonLd(): void {
  if (typeof document === 'undefined') return;
  document.head.querySelectorAll('script[data-seo-jsonld]').forEach((node) => node.remove());
}

export function buildWebSiteJsonLd(lang: string, description: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'CSSBuy Spreadsheet',
    url: siteUrl() + '/',
    description,
    inLanguage: langCode(lang),
  };
}

export function buildArticleJsonLd(
  article: { title: string; metaDescription: string },
  path: string,
  lang: string,
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: article.title,
    description: article.metaDescription,
    datePublished: PUBLISH_DATE,
    dateModified: PUBLISH_DATE,
    author: { '@type': 'Organization', name: ORG_NAME },
    publisher: { '@type': 'Organization', name: ORG_NAME },
    mainEntityOfPage: { '@type': 'WebPage', '@id': absoluteUrl(path) },
    image: SEO_IMAGES.article,
    inLanguage: langCode(lang),
  };
}

export function buildFaqJsonLd(faq: { q: string; a: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faq.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  };
}

export function buildCollectionJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Product Catalog',
    description:
      'The full CSSBuy Spreadsheet product catalog with curated fashion and lifestyle items across multiple categories.',
    url: absoluteUrl('/products'),
    mainEntity: {
      '@type': 'ItemList',
      numberOfItems: products.length,
      itemListElement: products.slice(0, 20).map((product, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: product.name,
        url: product.link,
        image: product.image,
      })),
    },
  };
}